import { render, staticRenderFns } from "./RegisterProduct.vue?vue&type=template&id=28f08162&scoped=true&"
import script from "./RegisterProduct.vue?vue&type=script&lang=js&"
export * from "./RegisterProduct.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProduct.vue?vue&type=style&index=0&id=28f08162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f08162",
  null
  
)

export default component.exports